export default "__VITE_ASSET__0dbc2288__"